import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { MAConfig } from './ma-config';
import { IConfigState, IDataState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IMAConfigStateProps {
  readonly ui: IUIState;
  readonly data: IDataState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IMAConfigConnectProps = IMAConfigStateProps & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IMAConfigStateProps {
  return {
    ui: state.ui,
    data: state.data,
    upload: state.upload,
    config: state.config
  };
}

export const MAConfigContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(MAConfig);
